import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import { ActionDialog, Loading } from './ActionDialog';

const tone = { Current: 'bg-green-100 text-green-800', Past: 'bg-gray-100 text-gray-600', Upcoming: 'bg-blue-100 text-blue-800' };

export const CertPeriodsDialog = ({ patientId, onClose }) => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/patients/${patientId}/cert-periods`).then(r => setData(r.data)).catch(() => setData({ periods: [] })); }, [patientId]);
  return (
    <ActionDialog title="Certification Periods" onClose={onClose} testid="cert-periods-dialog" wide>
      {!data ? <Loading /> : !data.periods.length ? (
        <p className="text-sm text-gray-600" data-testid="cert-periods-empty">No start of care date on file. Enter the Admit Date and save to see the 60-day periods.</p>
      ) : (
        <>
          <p className="text-sm text-gray-600 mb-3">Start of care: <b>{data.startOfCare}</b></p>
          <table className="w-full text-sm" data-testid="cert-periods-table">
            <thead><tr className="bg-gray-50 text-left text-gray-600"><th className="p-2">#</th><th className="p-2">From</th><th className="p-2">Thru</th><th className="p-2">Status</th><th className="p-2">485</th></tr></thead>
            <tbody>
              {data.periods.map(p => (
                <tr key={p.number} className="border-b" data-testid={`cert-period-${p.number}`}>
                  <td className="p-2">{p.number}</td><td className="p-2">{p.start}</td><td className="p-2">{p.end}</td>
                  <td className="p-2"><span className={`px-2 py-0.5 rounded-full text-xs ${tone[p.state]}`}>{p.state}{p.daysLeft != null ? ` · ${p.daysLeft} days left` : ''}</span></td>
                  <td className="p-2">
                    {p.poc485
                      ? <button className="text-[#1e40af] underline" onClick={() => navigate(`/dashboard/clinical/poc-485/edit?id=${p.poc485.id}&patientId=${patientId}`)}>{p.poc485.status}</button>
                      : <span className="text-gray-400">None</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </ActionDialog>
  );
};
